<template>
  <div class="dashboard__main-container">
    <div class="dashboard__info-box-container">
      <InfoBox 
        title="Clients"
        subTitle=""
        :count="200">
        <template #content>
          <div class="progress__container">
            <CustomProgressBar 
              :progressValue="60" 
              :progressMax="200"
              :progressHeight="8"
              variant="sucess" 
              progressLabel="Type 1"
              class="mt-1" />
            <CustomProgressBar 
              :progressValue="23" 
              :progressMax="200"
              :progressHeight="8"
              variant="sucess" 
              progressLabel="Type 2"
              class="mt-1" />
            <CustomProgressBar 
              :progressValue="70" 
              :progressMax="200"
              :progressHeight="8"
              variant="sucess" 
              progressLabel="Type 3"
              class="mt-1" />
          </div>
        </template>
      </InfoBox>
        
      <InfoBox 
        title="Contracts"
        subTitle=""
        :count="200">
        <template #content>
          <div class="progress__container">
            <CustomProgressBar 
              :progressValue="60" 
              :progressMax="200"
              :progressHeight="8"
              progressVariant="danger" 
              progressLabel="Pending"
              class="mt-1" />
            <CustomProgressBar 
              :progressValue="140" 
              :progressMax="200"
              :progressHeight="8"
              progressVariant="success" 
              progressLabel="Approved"
              class="mt-1" />
          </div>
        </template>
      </InfoBox>

      <InfoBox 
        title="Disbursements"
        subTitle=""
        :count="70">
        <template #content>
          <div class="progress__container">
            <CustomProgressBar 
              :progressValue="16" 
              :progressMax="70"
              :progressHeight="8"
              progressVariant="danger" 
              progressLabel="Pending"
              class="mt-1" />
            <CustomProgressBar 
              :progressValue="54" 
              :progressMax="70"
              :progressHeight="8"
              progressVariant="success" 
              progressLabel="Approved"
              class="mt-1" />
          </div>
        </template>
      </InfoBox>
    </div>
    
    <div class="dashboard__content-cotainer">
      <div class="dashboard__left-content"> 
        <!-- <CustomCard
          class="dashboard__chart"
          header="Yearly Sales Comparison"
          subHeader="Lorem ipsum, dolor sit amet consectetur adipisicing elit. Doloremque provident totam voluptates. Voluptates, nulla nobis.">
          <template #body>
            
          </template>
        </CustomCard> -->

        <div class="yearly__chart">
          <div class="yearly__chart-container">
            <div class="yearly__header"> 
              <div class="yearly__title">YEARLY COLLECTION COMPARISON</div>
              <!-- <div class="yearly__sub-title">Lorem ipsum dolor sit amet consectetur adipisicing.</div> -->
            </div>
            <div class="yearly__content">
              <ApexChart
                :series="yearlyComparisonChart.series" 
                :options="yearlyComparisonChart.options"
                class="dashboard__chart"
                id="test"
                key="test">
              </ApexChart>
            </div>
          </div>
          <div class="activity__feed">
          <div class="activity__feed-header">
            <v-icon name="rss-square" class="activity__feed-icon"/> <span class="activity__feed-title">  ACTIVITY FEED</span>
          </div>
          <div class="activity__feed-content" id="scroll-list">
            <Feed v-for="item in feed.items" :key="item.id" :feed="item"></Feed>
            <div class="loading-data" v-if="feed.isLoading">
              <v-icon name="spinner" spin class="spin-icon"></v-icon>
              <span>Loading Data...</span>
            </div>
            <div class="no-more-data" v-if="feed.items.length && feed.items.length === feed.pagination.totalRows">
              <span>No More Records To Show</span>
            </div>
            <div class="no-activity" v-if="!feed.isLoading && feed.items.length === 0 ">
              No Activity to display.
            </div>
          </div>
        </div>
        </div>

        <div class="other__chart-container">
          <div class="other__chart mr-1"> 
            <div class="other__header"> 
              <div class="other__title">COLLECTION BREAKDOWN</div>
              <!-- <div class="other__sub-title">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</div> -->
            </div>
            <div class="other__content">
              <ApexChart
                type="donut"
                :series="collectionBreakdownChart.series" 
                :options="collectionBreakdownChart.options"
                class="donut__chart">
              </ApexChart>
            </div>
          </div>
          <div class="other__chart ml-1"> 
            <div class="other__header"> 
              <div class="other__title">COLLECTION BREAKDOWN</div>
              <!-- <div class="other__sub-title">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</div> -->
            </div>
            <div class="other__content">
              <ApexChart
                type="donut"
                :series="collectionBreakdownChart.series" 
                :options="collectionBreakdownChart.options"
                class="donut__chart">
              </ApexChart>
            </div>
          </div>
        </div>
        
      </div>
      <!-- <div class="dashboard__right-content">
        
      </div> -->
    </div>
  </div>
</template>
<script>

import { CustomCard } from "./components";
import Feed from "./components/Feed";
import InfoBox from "./components/InfoBox"
import CustomProgressBar from "./components/CustomProgressBar"
import Full from "./components/Full"
import { AuditApi, PaymentApi } from '../mixins/api';
import { formatNumber } from '../helpers/forms';
import { PaymentTypes } from '../helpers/enum';

export default {
  name: 'Dashboard',
  mixins: [PaymentApi, AuditApi],
  components: {
    CustomCard,
    InfoBox,
    CustomProgressBar,
    Full,
    Feed
  },
  data () {
    return {
      selected: 'Month',
      feed: {
        isLoading: false,
        items: [],
        pagination: {
          from: 0,
          to: 0,
          totalRows: 0,
          page: 1,
          perPage: 10,
        }
      },
      yearlyComparisonChart: {
        series: [],
        options: {
          chart: {
            id: 'YearlyCollection',
            type:'area'
          },
          xaxis: {
            categories: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
          },
          yaxis: {
            decimalsInFloat: 0
          },
          markers: {
            size: 5,
          },
          dataLabels: {
            enabled: false
          },
          tooltip: {
            y: {
              formatter: function(value) {
                return formatNumber(value)
              }
            },
          }
        }
      },
      collectionBreakdownChart: {
        series: [],
        options: {
          labels: PaymentTypes.getNames(),
          legend: {
            position: 'bottom'
          },
          tooltip: {
            y: {
              formatter: function(value) {
                return formatNumber(value)
              }
            },
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  value: {
                    formatter: function(value) {
                      return formatNumber(value)
                    }
                  },
                  total: {
                    show: true,
                    label: 'Total',
                    color: '#373d3f',
                    formatter: function (w) {
                      return formatNumber(w.globals.seriesTotals.reduce((a, b) => {
                        return a + b
                      }, 0))
                    }
                  }
                }
              }
            }
          },
        },
      }
    }
  },
  created() {
    this.loadYearlyComparison()
    this.loadCollectionBreakdown()
    this.loadAuditList()
  },
  methods: {
    color (value) {
      let $color
      if (value <= 25) {
        $color = 'info'
      } else if (value > 25 && value <= 50) {
        $color = 'success'
      } else if (value > 50 && value <= 75) {
        $color = 'warning'
      } else if (value > 75 && value <= 100) {
        $color = 'danger'
      }
      return $color
    },
    loadYearlyComparison()
    {
      this.getYearlyCollectionComparison()
      .then(({data}) => {
        const { currentYear, previousYear } = data
        let currentYearData = []
        let previousYearData = []
        
        for(let x = 1; x <= 12; x++) {
          if(currentYear[x]) {
            currentYearData.push(currentYear[x])
          } else {
            currentYearData.push(0)
          }
          if(previousYear[x]) {
            previousYearData.push(previousYear[x])
          } else {
            previousYearData.push(0)
          }
        }

        const yearlyCollectionData = [
          {
            name: 'Current Year',
            data: currentYearData,
          },
          {
            name: 'Previous Year',
            data: previousYearData
          }
        ]
        this.yearlyComparisonChart.series = yearlyCollectionData
      }).catch(error => {
        console.log(error)
      })
    },
    loadCollectionBreakdown() {
      const params = {
        
      }
      this.getCollectionBreakdown(params)
      .then(({ data }) => {
        const collectionBreakdownData = PaymentTypes.values.map(p => {
          if(data[p.id]) {
            return data[p.id]
          } else {
            return 0
          }
        })
        // console.log(collectionBreakdownData)
        this.collectionBreakdownChart.series = collectionBreakdownData
      })
    },
    loadAuditList() {
      const { pagination, pagination: { perPage, page } } = this.feed
      const params = { paginate: true, perPage, page, orderBy: 'created_at', sort: 'DESC' }
      this.feed.isLoading = true
      this.getAuditList(params).then(({ data }) => {
        this.feed.items.push(...data.data)
        pagination.from = data.meta.from
        pagination.to = data.meta.to
        pagination.totalRows = data.meta.total
        this.feed.isLoading = false

        this.reloadAuditList()
      })
    },
    reloadAuditList(){
      const _this = this
      setInterval(function () {
        const { items, pagination } = _this.feed
        const latestAudit = items[0]
        if (latestAudit) {
          const { id } = latestAudit
          const params = { paginate: true, perPage: 100, page: 1, orderBy: 'created_at', sort: 'DESC', id }
          _this.getAuditList(params).then(({ data }) => {
            items.unshift(...data.data)
            pagination.from = data.meta.from
            pagination.to = data.meta.to
            pagination.totalRows = data.meta.total
          })
        }
      }, 180000)
    },
    handleScroll(e) {
      const element = e.target;
      const { isLoading, items, pagination } = this.feed
      if(element.scrollTop + element.clientHeight >= element.scrollHeight) {
        if(!isLoading && !(items?.length === pagination.totalRows)) {
          pagination.page++
          this.loadAuditList()
        }
      }
    }
  },
  mounted() {
    const feedContainer = document.getElementById('scroll-list')
    feedContainer.addEventListener("scroll", this.handleScroll)
  },
  destroyed() {
    const feedContainer = document.getElementById('scroll-list')
    feedContainer.removeEventListener("scroll", this.handleScroll)
  },
}
</script>

<style lang="scss" scoped>

  .content-header {
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;

    .search-input {
      width: 240px;
      position: absolute;
      right: 0;
    }
  }

  .dashboard__info-box-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .progress__container {
    width: 100%;
    display: flex;
    height: 100%;
    align-items: center;
    flex-direction: column;
    padding: 10px 20px;
  }

  .dashboard__main-container {
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    padding: 20px;
  }

  .dashboard__content-cotainer {
    display: flex;
    height: 100%;
    width: 100%;
    margin: 20px 0px;
  }

  .dashboard__left-content {
    flex: 1;
    margin-right: 10px;
    height: 100%;
  }

  .dashboard__right-content {
    max-width: 325px;
    min-width: 325px;
    display: flex;
    min-height: 100%;
  }

  .dashboard__chart {
    width: 80%;
    height: auto;
  }

  .donut__chart {
    width: 100%;
    height: auto;
  }

  .yearly__chart {
    display: flex;
    
    .yearly__chart-container {
      flex: 1;
      border: solid 1px lightgray;
      background-color: white;
      margin-right: 10px;

      .yearly__header {
        padding: 10px 15px;
        border-bottom: solid 1px lightgray;

        .yearly__title {
          font-size: 16pt;
          font-weight: bold;
        }

        .yearly__sub-title {
          font-size: 9pt;
          color: gray;
        }
      }

      .yearly__content {
        padding: 10px 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .activity__feed {
      width: 325px;
      max-height: 700px; 
      border: solid 1px lightgray;
      background-color: white;

      .activity__feed-header {
        padding: 10px;
        display: flex;
        height: 60px;
        align-items: center;
        border-bottom: solid 1px lightgray;
        margin-bottom: 5px;

        .activity__feed-title {
          font-size: 20pt;
        }

        .activity__feed-icon {
          height: 30px;
          width: 30px;
          margin-right: 10px;
        }
      }

      .activity__feed-content {
        padding: 10px;
        max-height: 620px;
        overflow-y: auto;
        width: 100%;
        display: flex;
        flex-direction: column;
      }
    }
  }

  .other__chart-container{
    height: auto;
    width: 100%;
    display: flex;
    margin-top: 20px;
    

    .other__chart {
      border: solid 1px lightgray;
      background-color: white;
      width: 50%;

      .other__header {
        padding: 10px 15px;
        border-bottom: solid 1px lightgray;

        .other__title {
          font-size: 16pt;
          font-weight: bold;
        }

        .other__sub-title {
          font-size: 9pt;
          color: gray;
        }
      }

      .other__content {
        padding: 10px 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: auto;
      }
    }
  }

  .no-activity {
    display:  flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    font-weight: bold;
  }

  .loading-data{
    height: 35px;
    width: 100%;
    display: flex;
    background-color: white;
    align-items: center;
    justify-content: center;
    opacity: 0.5;

    .spin-icon {
      margin-right: 10px;
    }
  }

  .no-more-data {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 10pt;
    color: gray;
    margin-bottom: 10px;
  }

    /* width */
  .activity__feed-content::-webkit-scrollbar {
    width: 5px;
  }

  /* Handle */
  .activity__feed-content::-webkit-scrollbar-thumb {
    background: rgb(160, 160, 160);
    border-radius: 5px;
  }

  @media screen and (max-width: 1024px) {
    .activity__feed {
      max-height: 500px!important; 
    }
    .activity__feed-content {
      max-height: 420px!important;
    }

  }

  @media screen and (max-width: 800px) {
    .activity__feed {
      width: 250px!important; 
      max-height: 350px!important; 
    }
    .activity__feed-content {
      max-height: 270px!important;
    }
  }



</style>
